import { ENVIRONMENT, getEnvironment } from '../utils/environment';

const SENTINEL_DOMAINS: Record<string, string> = {
  lowerEnv: process.env.REACT_APP_SENTINEL_DOMAIN_LOWER_ENV || 'https://idx-stage.linkhealth.com/auth/realms/developer-platform',
  higherEnv: process.env.REACT_APP_SENTINEL_DOMAIN_HIGHER_ENV || 'https://idx.linkhealth.com/auth/realms/developer-platform',
};

const environment = getEnvironment();

const defaultSentinelId = process.env.REACT_APP_SENTINEL_ID || 'HPS_Sntl_AI-Assistant_v1';

const SENTINEL_ID_MAP: Record<string, string> = {
  [ENVIRONMENT.DEV]: process.env.REACT_APP_SENTINEL_ID_DEV || defaultSentinelId,
  [ENVIRONMENT.QA]: process.env.REACT_APP_SENTINEL_ID_QA || defaultSentinelId,
  [ENVIRONMENT.STG]: process.env.REACT_APP_SENTINEL_ID_STG || defaultSentinelId,
  [ENVIRONMENT.PRD]: process.env.REACT_APP_SENTINEL_ID_PRD || defaultSentinelId,
};

export const sentinelId = (): string => SENTINEL_ID_MAP[environment] || '';

const SENTINEL_STAGE_MAP: Record<string, string> = {
  [ENVIRONMENT.DEV]: 'lowerEnv',
  [ENVIRONMENT.QA]: 'lowerEnv',
  [ENVIRONMENT.STG]: 'higherEnv',
  [ENVIRONMENT.PRD]: 'higherEnv',
};

export const getSentinelStage = (): string => SENTINEL_STAGE_MAP[environment] || '';

export const getSentinelAuthority = (): string => SENTINEL_DOMAINS[getSentinelStage()];

const onSigninCallback = (): void => {
  window.history.replaceState({}, document.title, window.location.pathname);
};

export const oidcConfig = {
  client_id: sentinelId(),
  authority: getSentinelAuthority(),
  scope: process.env.REACT_APP_SENTINEL_SCOPE || 'openid profile email',
  redirect_uri: process.env.REACT_APP_SENTINEL_REDIRECT_URI || window.location.origin,
  post_logout_redirect_uri: process.env.REACT_APP_SENTINEL_POST_LOGOUT_REDIRECT_URI || window.location.origin,
  silent_redirect_uri: process.env.REACT_APP_SENTINEL_SILENT_REDIRECT_URI || window.location.origin,
  automaticSilentRenew: true,
  monitorSession: true,
  loadUserInfo: true,
  onSigninCallback,
};
